/* @flow */
import qs from 'qs';
import { ResponseTypes, ButtonActionTypes } from 'constants/QuickPromotionConstants';
import QuickPromotion from 'entities/QuickPromotion';
import QuickPromotionAction from 'entities/QuickPromotionAction';
import QuickPromotionActions from 'actions/QuickPromotionActions';
import resolveDeeplinkRedirects from 'lib/resolveDeeplinkRedirects';

export const actionHandlers = {
  handleActionLink: (action: QuickPromotionAction) => {
    window.location = action.getActionData();
  },
  handleActionDeeplink: (router: Object, action: QuickPromotionAction, data: ?Object) => {
    const url = action.getActionData() + (data ? '?' + qs.stringify(data) : '');
    router.push(resolveDeeplinkRedirects(url));
  },
};

export function handleAction(
  router: Object,
  promotion: QuickPromotion,
  action: QuickPromotionAction,
  data: ?Object
) {
  switch (action.getActionType()) {
    case ButtonActionTypes.NONE:
      // do nothing
      break;
    case ButtonActionTypes.LINK:
      actionHandlers.handleActionLink(action);
      break;
    case ButtonActionTypes.DEEPLINK:
      actionHandlers.handleActionDeeplink(router, action, data);
      break;
    default:
      console.error(
        "Don't know how to handle this QP action. The QP shouldn't have been shown." +
          ' action: ' +
          action.toString() +
          ' offending QP ' +
          promotion.toString()
      );
      break;
  }
}

export async function handleResponse(
  router: Object,
  promotion: QuickPromotion,
  responseType: string,
  data: ?Object
) {
  // Block on recording dismissals to prevent a race condition.
  await QuickPromotionActions.recordDismissal(promotion, responseType);

  switch (responseType) {
    case ResponseTypes.PRIMARY_ACTION:
      handleAction(router, promotion, promotion.getPrimaryAction(), data);
      break;
    case ResponseTypes.SECONDARY_ACTION:
      const secondaryAction = promotion.getSecondaryAction();
      if (secondaryAction != null) {
        handleAction(router, promotion, secondaryAction, data);
      } else {
        console.error(
          'QP has no secondary action. This QP should not have been shown.' +
            ' offending QP: ' +
            promotion.toString()
        );
      }
      break;
    default:
      console.error(
        'Unknown QP response type. This should never happen.' +
          ' responseType: ' +
          responseType +
          ' offending QP: ' +
          promotion.toString()
      );
      break;
  }
}
